import { observer } from "mobx-react-lite";
import { useContext, useEffect, useRef, useState } from "react";
import AutoTextArea from "../ui/AutoTextArea";
import MultiSwitcherStage from "../ui/MultiSwitcherStage";
import useNotification from "../../hooks/useNotification";
import { ReactComponent as RemoveIcon } from "../../images/icons/contextRemove.svg";
import { Context } from "../..";

const RateOptionsCard = ({ value, setValue, saveValue, onDelete, index, isNew }) => {
    const { store } = useContext(Context);
    const { error } = useNotification();
    const [width, setWidth] = useState(0);
    const span = useRef(null);

    const rowRef = useRef(null);
    const inputRef = useRef(null);
    const numberInput = useRef(null);
    const [editMode, setEditMode] = useState(isNew ? true : false);
    const [isRemove, setRemove] = useState(false);

    useEffect(() => {
        if (isNew && inputRef.current && store.userInfo && store.userInfo.isLicensed == true) {
            setEditMode(true);
            inputRef.current.focus();
        }
    }, []);
    useEffect(() => {
        setWidth(span.current.offsetWidth);

        const handleClickOutside = (event) => {
            if (rowRef.current && !rowRef.current.contains(event.target) && event.target.id != "notificationButton") {
                save();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [value, editMode]);
    
    function save() {
        if (!editMode) return;
        if (!inputRef.current) return;
        inputRef.current.blur();

        const confirmSave = () => {
            setEditMode(false);
            saveValue(value);
        }

        const handleNewItem = () => {
            if (value.cost == 0) {
                if (!validateFields()) onDelete();
                else confirmSave();
            } else {
                if (validateFields(true)) confirmSave();
            }
        }

        if (!isNew && validateFields(true)) confirmSave();
        else if (isNew) handleNewItem();
    }
    const validateFields = (showError) => {
        if (value.name.replace(" ", "") == "") {
            inputRef.current.className = "error";
            if (showError) error('Поле "Наименование" не может быть пустым', { showBtns: false });
            return false;
        }
        inputRef.current.className = "";
        return true;
    }

    let timeoutRemove;
    const remove = () => {
        if (isRemove === true) return;
        setRemove(true);
        if (isNew) {
            onDelete();
            return;
        }
        timeoutRemove = setTimeout(() => setRemove(false), 3000); 
    }
    const confirmRemove = () => {
        if (isRemove === false) return;
        clearTimeout(timeoutRemove);
        setRemove(false);
        onDelete();
    }

    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <li 
            ref={rowRef} 
            className={`${editMode ? "active" : ""}${isRemove?" remove":""}`}
        >
            <div className="left">
                <div className="num">{index+1}.</div>
                <div className="name">
                    <div className="text" style={{ cursor: "pointer" }} onClick={() => {
                        if (!store.userInfo || store.userInfo.isLicensed == false) return;
                        setEditMode(true)
                        setTimeout(() => inputRef.current.focus(), 0);
                    }}>
                        {editMode 
                            ? <AutoTextArea 
                                ref={inputRef}
                                active={editMode} 
                                value={value.name} 
                                setValue={(value) => setValue(value, "name")}
                                save={save}
                            />
                            : value.name 
                        }
                    </div>
                    {/* <ul className="tags">
                        <li>проверка</li>
                        <li>51 счет</li>
                    </ul> */}
                </div>
            </div>
            <MultiSwitcherStage
                values={[{ name: "Нет" }, { name: "Да" }]}
                selectValue={(selectedIndex) => {
                    const selected = selectedIndex == 0 ? false : true;
                    if (selected == value.isMulti) return;
                    setValue(selected, 'isMulti');
                    if (!editMode) saveValue({ ...value, isMulti: selected });
                }}
                backIsWhite={true}
                forceSelected={value.isMulti == true ? 1 : 0}
                defaultValue={0}
                disabled={!store.userInfo || store.userInfo.isLicensed == false}
            />
            <div className="right">
                <ul className="params">
                    <li style={{ maxWidth: 250, width: 250, justifyContent: "end" }}>
                        <span ref={span}>{formatNumber(Number(value.cost))}</span>
                        {/* <div className="text">В месяц:</div> */}
                        <div className="value" onClick={(event) => {
                            numberInput.current.focus();
                            setEditMode(true);
                        }}><input 
                            ref={numberInput}
                            type="text" 
                            style={{ width }} 
                            // value={value.cost == "" ? "" : formatNumber(Number(value.cost))} 
                            value={value.cost == "" ? value.cost : formatNumber(Number(value.cost))} 
                            onChange={(e) => {
                                const rawValue = e.target.value.replace(/\D/g, '');
                                setValue(rawValue === '' ? 0 : rawValue, "cost");
                                if (!editMode) saveValue({ ...value, cost: rawValue === '' ? 0 : rawValue });
                            }}
                            onFocus={() => {
                                if (value.cost == 0) setValue("", "cost");
                            }}
                            onBlur={() => {
                                if (value.cost == "") setValue(0, "cost");
                            }}
                            onKeyDown={(event) => event.key === "Enter" && save()}
                            disabled={!store.userInfo || store.userInfo.isLicensed == false}
                        /> ₽</div>
                    </li>
                </ul>
                <button 
                    className="remove"
                    onClick={() => {
                        if (!store.userInfo || store.userInfo.isLicensed == false) return;
                        if (isRemove === false) remove();
                        else confirmRemove();
                    }}
                >
                    <RemoveIcon/>
                </button>
            </div>
        </li>
    );
}

export default observer(RateOptionsCard);
